import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage21.module.css";

export default function LaymanPage21() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            {/* <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>VENERATION OF THE NEW MOON</h1>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="common_leftright_pattern_titleblock">
                  <div className="common_leftright_pattern_titleblock_commonwidth">
                    <span className="common_leftright_pattern_titleblock_inner">
                      <div className="common_leftright_pattern_titleblock_header_wrapper">
                        <h1
                          className="common_leftright_pattern_titleblock_header"
                          
                        >VENERATION OF THE NEW MOON</h1>
                      </div>
                    </span>
                  </div>
                </div>

            <div className={styles.common_width}>
              <div className={styles.layman_new_moon_block_main}>
                <div
                  className={`${styles.new_moon_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.new_moon_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/new_moon_block1_img.webp"
                    /> */}
                    <img
                      className={styles.new_moon_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/veneration_of_the_moon/new_moon_block1_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>
                          Embracing Darkness: The New Moon's Journey into the
                          Underworld
                        </h1>
                      </div>

                      <h2>Introduction:</h2>

                      <p>
                        As the moon begins its subtle transition from crescent
                        sliver to the shadowy veil of the new moon, a sacred and
                        transformative process unfolds—one deeply woven into the
                        fabric of the School of Divine Infinite Being method. In
                        this lunarphase, we embark on a profound journey into
                        the underworld of our own psyche, confronting the
                        shadows that dwell within. The new moon becomes a portal
                        to the primal realms of ourinstincts and the animalistic
                        nature of our being. Rooted in ancient traditions and
                        guided by the goddess Nyx, ruler of the
                        night, the new moon's energies beckon us to delve into
                        the darkestrecesses of our consciousness, facing fears
                        and embracing the mysteries that lie hidden in the
                        shadows.
                      </p>

                      <h2>The Primal Shadow Self:</h2>

                      <p>
                        At the heart of the new moon's influence lies the primal
                        shadow self—a repository of our most instinctual and
                        animalistic aspects. These shades, the repressions of
                        our experiences that have been thrust into the
                        Unconscious, manifest as our deepest fears and the
                        existential horrors we shy away from acknowledging.{" "}
                        Nyx, the goddess of night, presides over
                        this enigmatic realm, where the lunar energies of our
                        unconscious take on their most abstract forms. Here, in
                        the darkness ruled by Nyx, we confront our innermost
                        insecurities and traverse the corridors of our darkest
                        selves.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img className={styles.layman_main_img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/new_moon_block2_img.webp" /> */}
                    <img
                      className={styles.layman_main_img}
                      src={`${process.env.cloud_url}Layman-Symbolism/veneration_of_the_moon/new_moon_block2_img.webp`}
                    />

                    {/* <img className={styles.layman_sub_img} src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/new_moon_block2_img_1199v.webp" /> */}
                    <img
                      className={styles.layman_sub_img}
                      src={`${process.env.cloud_url}Layman-Symbolism/veneration_of_the_moon/new_moon_block2_img_1199v.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <h2>Hecate's Underworld:</h2>

                      <p>
                        During the new moon cycles, we turn our gaze to Hecate,
                        the goddess of the underworld. In her realm, we confront
                        our shadows head-on, committing to bringing to light our
                        shortcomings and embracing the transformative power of
                        self-awareness. Hecate becomes our guide through the
                        labyrinthine passages of the unconscious, where we
                        gather the torn fragments of our Dionysian essence,
                        preparing for the eventual resurrection into the cycle
                        of life.
                      </p>

                      <h2>Tarot Symbolism: The Moon (T-18):</h2>

                      <p>
                        In the Tarot, the Moon card (T-18) captures
                        the essence of the new moon's energy. It is a sinister
                        place of blindness, symbolized by a dung beetle rolling
                        its eggs in deep faith that the sun will rise, hatching
                        its offspring. This symbolic representation draws us
                        into the Underworld, the realm of dark nights and the
                        hidden power of our instincts. The Moon card invites us
                        to navigate the mysteries of our unconscious with
                        unwavering trust, acknowledging that even in the darkest
                        moments, a new dawn awaits.
                      </p>

                      <h2>Conclusion:</h2>

                      <p>
                        As we stand beneath the veiled brilliance of the new
                        moon, we embark on a sacred journey into the depths of
                        our own underworld. Guided by the goddess Nyx and
                        accompanied by the transformative presence of Hecate, we
                        confront the shadows that lurk within, committing to the
                        alchemical process of self-discovery. The new moon, with
                        its abstract lunar energies, becomes a mirror reflecting
                        the primal aspects of our being, urging us to embrace
                        the darkness within and emerge reborn with the rising
                        sun. In this cyclical dance with the new moon, we find a
                        powerful tool for self-realization and a gateway to the
                        mysteries that reside in the shadowy corners of our
                        consciousness.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.new_moon_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/new_moon_block3_nw_img.webp"
                    /> */}
                    <img
                      className={styles.new_moon_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/veneration_of_the_moon/new_moon_block3_nw_img.webp`}
                    />
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <p>
                        <b>New Moon Phase:</b> The veneration of the New Moon
                        focuses on the specific lunar phase when the moon is not
                        illuminated from Earth's perspective, marking the
                        beginning of a new lunar cycle.
                      </p>

                      <p>
                        <b>Sun-Moon Conjunction:</b> The New Moon occurs when
                        the Sun and Moon are in the same astrological sign,
                        symbolizing a conjunction that aligns the conscious{" "}
                        (Sun) and unconscious (Moon){" "}
                        aspects of the self.
                      </p>

                      <p>
                        <b>Zodiacal Sign:</b> Astrologically, the position of
                        the New Moon within a zodiacal sign is significant,
                        influencing the overall energy and themes associated
                        with the ritual. Each sign adds a unique flavor to the
                        intentions set during the New Moon.
                      </p>

                      <p>
                        <b>Aspects to Other Planets:</b> Consideration of
                        aspects{" "}(conjunctions, sextiles, squares, etc.){" "}
                        between the New Moon and other planets in the
                        astrological chart provides insights into the broader
                        celestial influences during this phase.
                      </p>

                      <p>
                        <b>Planetary Rulership:</b> Identifying the planetary
                        ruler of the sign in which the New Moon occurs adds
                        layers to the astrological interpretation, offering
                        clues about the specific energies at play.
                      </p>

                      <p>
                        <b>House Placement:</b> The astrological house in which
                        the New Moon falls in an individual's natal chart or in
                        a ritual chart influences the areas of life where new
                        beginnings, intentions, and transformations may
                        manifest.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/new_moon_block4_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/veneration_of_the_moon/new_moon_block4_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Transits:</b> Examining transits to the New Moon
                        position from other planets in the sky offers additional
                        astrological context, indicating potential supportive or
                        challenging energies.
                      </p>

                      <p>
                        <b>Lunar Mansions:</b> Some practitioners consider the
                        lunar mansions or Nakshatras, which are specific
                        divisions of the moon's orbit, for a more nuanced
                        understanding of the New Moon's influence.
                      </p>

                      <p>
                        <b>Lunar Nodes:</b> The position of the lunar nodes{" "}
                        (North Node and South Node) during the New
                        Moon provides insights into karmic aspects and life path
                        influences associated with this phase.
                      </p>

                      <p>
                        <b>Fixed Stars:</b> Astrologers may also take into
                        account the influence of fixed stars in proximity to the
                        New Moon, as their positions can contribute symbolic
                        meanings or amplify certain energies.
                      </p>

                      <p>
                        <b>Retrograde Planets:</b> The presence of retrograde
                        planets during the New Moon can influence the overall
                        astrological atmosphere, emphasizing introspection and
                        revisiting past experiences.
                      </p>

                      <p>
                        <b>Sabian Symbols:</b> Exploring the Sabian Symbols
                        associated with the specific degree of the New Moon in a
                        zodiac sign can provide symbolic images that deepen the
                        astrological interpretation.
                      </p>

                      <p>
                        <b>Eclipses:</b> While not a regular occurrence, the New
                        Moon can coincide with a solar eclipse, adding a potent
                        astrological dimension and intensifying the
                        transformative nature of this lunar phase.
                      </p>

                      <p>
                        <b>Personal Natal Chart:</b> Individuals often explore
                        their personal natal charts to understand how the New
                        Moon aligns with their unique astrological
                        configurations, allowing for a more personalized and
                        meaningful veneration practice.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for the New Moon{" "}
                          <br />
                          is The Moon. See our alchemical ROTA here
                        </h1>
                      </div>
                    </Link>
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/vene_moon_block1_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/vene_moon_block2.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/vene_moon_block3_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/vene_moon_block4_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/veneration_of_the_moon/vene_moon_link_block.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
